
import Vue from "vue";
import { AuthService } from "@/services/auth-service";


export default Vue.extend({
	data() {
		return {};
	},
	computed: {
		firstname(){
			return AuthService.wfUser.Firstname;
		},
		email(){
			return AuthService.wfUser.Email;
		}
	},
	methods: {
		async verifyEmailClicked(){
			await AuthService.resendActivationEmail();
			let text = this.$ct("activation-email-info",
				{email: AuthService.wfUser.Email});
			this.$wf.dialog(text, this.$ct("common.Ok"), this.$ct("activation-email-sent"));
		}
	},
	i18nEx: {
		componentPrefix: "views.HomeRoute"
	}
});

